module.exports = __webpack_public_path__ + "static/media/gmv-exp-mobile.5ae175df.png";